require('jquery-ui/ui/widget');
require('jquery-ui/ui/disable-selection');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/resizable.css');